import AbstractComponent from './AbstractComponent';

export default class BlogOverview extends AbstractComponent {
  /**
   * The HTML elements of the blog cards.
   */
  private $cards: NodeListOf<HTMLElement>;

  /**
   * Initializes the blog overview.
   */
  public initialize(): void {
    this.$cards = document.querySelectorAll('.blog__cards.is-overview .blog__card');

    window.addEventListener('resize', () => this.showInViewCards());
    window.addEventListener('scroll', () => this.showInViewCards());

    this.showInViewCards();
  }

  /**
   * Calculates which cards are in view, and add a class to those cards.
   */
  private showInViewCards(): void {
    const windowHeight = window.innerHeight;

    this.$cards.forEach(($card) => {
      if ($card.classList.contains('.is-in-view')) {
        return;
      }

      if (window.scrollY + windowHeight >= $card.offsetTop + 100) {
        $card.classList.add('is-in-view');
      }
    });
  }
}
